export const DTMF_OPTIONS = { duration: 220 };
export const DONE_TYPING_DTMF = 1000;
